import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { showError } from '../utils/notifications';
import API_CONFIG from '../config';
import { getCategoryImage } from '../config/categoryImages';

const Dashboard = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Fonction pour obtenir le style visuel de chaque catégorie
  const getCategoryStyle = (categoryName, categoryIcon) => {
    // Utiliser les images locales
    const categoryImage = getCategoryImage(categoryName);
    
    return {
      backgroundImage: `url('${categoryImage.path}')`,
      textColor: 'text-white'
    };
  };

  // Charger les données au démarrage
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    const fetchData = async () => {
      try {
        // Récupérer les données utilisateur
        const userResponse = await fetch(`${API_CONFIG.BASE_URL}/auth/me`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        if (!userResponse.ok) {
          localStorage.removeItem('token');
          navigate('/login');
          return;
        }
        
        await userResponse.json();
        
        // Récupérer toutes les catégories disponibles
        await fetchCategories();
      } catch (error) {
        console.error("Erreur:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [navigate]);
  
  // Récupération de toutes les catégories
  const fetchCategories = async () => {
    const token = localStorage.getItem('token');
    try {
      const categoriesResponse = await fetch(`${API_CONFIG.BASE_URL}/categories`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (categoriesResponse.ok) {
        const categoriesData = await categoriesResponse.json();
        setCategories(categoriesData);
      }
    } catch (error) {
      console.error("Erreur catégories:", error);
    }
  };
  
  const handleCategoryClick = (categoryId) => {
    navigate(`/categories/${categoryId}/products`);
  };

  if (loading) {
    return <div className="min-h-screen flex justify-center items-center"><p>Chargement...</p></div>;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Contenu principal */}
      <main className="py-4 sm:py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Liste de catégories */}
          <div className="mb-6">
            {/* Titre Accueil centré */}
            <div className="text-center mb-6">
              <h2 className="text-lg sm:text-xl font-semibold">Accueil</h2>
            </div>
            
            {/* Barre de recherche */}
            <div className="mb-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Rechercher une catégorie..."
                  className="w-full px-4 py-3 pl-10 pr-4 bg-gray-100 border-0 rounded-lg focus:ring-2 focus:ring-primary focus:bg-gray-50"
                />
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
              </div>
            </div>
            
            {/* Titre Categories */}
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Categories</h3>
            </div>
            
            <div>
              {categories.length === 0 ? (
                <div className="bg-white shadow sm:rounded-lg p-6 text-center text-gray-500">
                  <p className="text-sm sm:text-base">Aucune catégorie disponible pour le moment.</p>
                </div>
              ) : (
                <div className="h-[calc(100vh-300px)] overflow-y-auto pr-2 scrollbar-hide">
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
                    {categories.map((category) => {
                      const categoryStyle = getCategoryStyle(category.name, category.icon);
                      return (
                        <div 
                          key={category.id} 
                          className="rounded-lg shadow-md cursor-pointer hover:shadow-lg transition-all duration-200 relative h-28 sm:h-36 flex flex-col overflow-hidden group"
                          onClick={() => handleCategoryClick(category.id)}
                          style={{ 
                            backgroundImage: categoryStyle.backgroundImage, 
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                          }}
                        >
                          {/* Contenu principal */}
                          <div className="flex flex-col justify-end h-full p-3 sm:p-4 relative z-10">
                            <h3 className={`font-semibold text-center text-sm sm:text-base leading-tight ${categoryStyle.textColor} drop-shadow-lg`}>
                              {category.name}
                            </h3>
                          </div>

                          {/* Effet hover */}
                          <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity"></div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard; 